"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
require("./Dialog.css");
var dialog_1 = require("@csod/dialog");
exports.Dialog = dialog_1.default;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Dialog"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/Dialog/Dialog.js
// module id = 420
// module chunks = 0